export const overlay = {
    background: "linear-gradient(203.89deg, rgba(5, 30, 52, 0.78) 0%, rgba(5, 30, 52, 0.42) 100%);"
};
export const formBlock = {
    px: [24, null, null, 0],
    mt: 40,
    mb: [72, 128],
    mx: "auto",
    width: ["100%", null, null, "calc(100vw * .375)"],
    maxWidth: "48ch"
};
export const formButtonSingleContainer = {
    width: "100%",
    maxWidth: ["100%", null, null, "30ch"]
};
//# sourceMappingURL=layouts.js.map